module.exports = __webpack_public_path__ + "static/media/sialkot.7d62d221.svg";